import { useState } from 'react';
import { FiArrowUpRight, FiMapPin, FiWifi, FiClock, FiCoffee } from 'react-icons/fi';
import patio from '../images/patio.png';

export default function Services() {
  const [fechaEntrada, setFechaEntrada] = useState('');
  const [fechaSalida, setFechaSalida] = useState('');
  const [cantidadPersonas, setCantidadPersonas] = useState(1);
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  const formatDate = (value) => value.split('-').reverse().join('/');
  const valid = fechaEntrada >= today && fechaSalida >= fechaEntrada && Number(cantidadPersonas) >= 1 && Number(cantidadPersonas) <= 12;
  const consultar = (event) => {
    event.preventDefault();
    if (!valid) return;
    const message = `Hola, quiero consultar disponibilidad para el Hotel Raglan.\nFecha de entrada: ${formatDate(fechaEntrada)}\nFecha de salida: ${formatDate(fechaSalida)}\nCantidad de personas: ${cantidadPersonas}`;
    window.open(`https://wa.me/5492233555110?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  };
  return (
    <section id="services" className="welcome-section">
      <div className="hotel-hero">
        <img className="hero-photo" src={patio} alt="Patio del Hotel Raglan en Mar del Plata" fetchpriority="high" />
        <div className="hero-shade" />
        <div className="hero-copy">
          <span className="hero-kicker"><FiMapPin aria-hidden="true" /> EN EL CORAZÓN DE MAR DEL PLATA</span>
          <h1>Tu lugar para<br />disfrutar <em>la ciudad.</em></h1>
          <p>Una estadía sencilla, cálida y cerca de todo.<br />Descansá, recorré y sentite como en casa.</p>
          <a className="hero-link" href="#habitaciones">Conocé nuestras habitaciones <FiArrowUpRight aria-hidden="true" /></a>
        </div>
        <span className="hero-location">BOLÍVAR 2556 · MAR DEL PLATA</span>
      </div>
      <form id="consulta" className="stay-query" onSubmit={consultar}>
        <div className="query-title"><span className="eyebrow">TU PRÓXIMA ESCAPADA</span><h2>Consultá tu estadía</h2><p>Te respondemos por WhatsApp.</p></div>
        <label>Entrada<input type="date" required min={today} value={fechaEntrada} onChange={(event) => setFechaEntrada(event.target.value)} /></label>
        <label>Salida<input type="date" required min={fechaEntrada || today} value={fechaSalida} onChange={(event) => setFechaSalida(event.target.value)} /></label>
        <label>Personas<input type="number" required min="1" max="12" value={cantidadPersonas} onChange={(event) => setCantidadPersonas(event.target.value)} /></label>
        <button type="submit" className="primary-button" disabled={!valid || !fechaSalida}>Consultar <FiArrowUpRight aria-hidden="true" /></button>
      </form>
      <div className="hotel-intro"><div><span className="eyebrow">BIENVENIDOS A HOTEL RAGLAN</span><h2>Lo mejor de tu viaje<br />empieza con un buen descanso.</h2></div><div><p>En pleno centro de Mar del Plata, te esperamos con habitaciones y apartamentos de estilo sencillo y tradicional, desayuno incluido y la calidez de un lugar para volver.</p><div className="intro-perks"><span><FiCoffee /> Desayuno incluido</span><span><FiWifi /> Wifi</span><span><FiClock /> Recepción 24 h</span></div></div></div>
    </section>
  );
}
